export default "<app-loader [isLoading]=\"isLoading\"></app-loader>\n<div [hidden]=\"isLoading\">\n  <r-references #referencesRef></r-references>\n</div>\n";